var map = {
	"./img_data00.png": 79001,
	"./img_data01.png": 98448,
	"./img_data02.png": 51947,
	"./img_data03.png": 30818,
	"./img_data04.png": 27165,
	"./img_data05.png": 6036,
	"./img_data06.png": 24943,
	"./img_data07.png": 2278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93513;